import { type ListAllVoucherUsersQuery } from '~/services/PromoService';

import { type SelectedVoucherUser } from './voucherUserBulkBatches';

type Page = { total: number; voucherUsers: Array<SelectedVoucherUser> };

/** Collect before deleting: offset pagination would skip rows if deletion happened between page reads. */
export async function loadVoucherUserSnapshot(
  query: ListAllVoucherUsersQuery,
  expectedTotal: number,
  loadPage: (query: ListAllVoucherUsersQuery) => Promise<Page>,
  onProgress?: (loaded: number) => void,
): Promise<Array<SelectedVoucherUser>> {
  const rows = new Map<string, SelectedVoucherUser>();
  const limit = query.limit ?? 50;
  if (limit <= 0) throw new Error('A positive page size is required.');
  for (let page = 0; rows.size < expectedTotal; page += 1) {
    const result = await loadPage({ ...query, page, limit });
    if (result.total !== expectedTotal || result.voucherUsers.length === 0) {
      throw new Error('Matching records changed while loading. Refresh the list and preview again.');
    }
    for (const row of result.voucherUsers) {
      if (rows.has(row.voucherUserId)) {
        throw new Error('Matching pages overlapped while loading. Refresh the list and preview again.');
      }
      rows.set(row.voucherUserId, row);
    }
    if (rows.size > expectedTotal) throw new Error('The matching record count changed. Refresh and preview again.');
    onProgress?.(rows.size);
  }
  return [...rows.values()];
}
